module.exports = __webpack_public_path__ + "img/logo.05fb1a50.png";